
export type KeyCode = number;
export let KeyCode: any = {};
KeyCode.Shift = 16;
KeyCode.Up = 38;
KeyCode.Down = 40;
KeyCode.Left = 37;
KeyCode.Right = 39;
KeyCode.A = 65;
KeyCode.B = 66;
KeyCode.C = 67;
KeyCode.D = 68;
KeyCode.E = 69;
KeyCode.F = 70;
KeyCode.G = 71;
KeyCode.H = 72;
KeyCode.I = 73;
KeyCode.J = 74;
KeyCode.K = 75;
KeyCode.L = 76;
KeyCode.M = 77;
KeyCode.N = 78;
KeyCode.O = 79;
KeyCode.P = 80;
KeyCode.Q = 81;
KeyCode.R = 82;
KeyCode.S = 83;
KeyCode.T = 84;
KeyCode.U = 85;
KeyCode.V = 86;
KeyCode.W = 87;
KeyCode.X = 88;
KeyCode.Y = 89;
KeyCode.Z = 90;
KeyCode[KeyCode.Shift] = "Shift";
KeyCode[KeyCode.Up] = "Up";
KeyCode[KeyCode.Down] = "Down";
KeyCode[KeyCode.Left] = "Left";
KeyCode[KeyCode.Right] = "Right";
KeyCode[KeyCode.A] = "A";
KeyCode[KeyCode.B] = "B";
KeyCode[KeyCode.C] = "C";
KeyCode[KeyCode.D] = "D";
KeyCode[KeyCode.E] = "E";
KeyCode[KeyCode.F] = "F";
KeyCode[KeyCode.G] = "G";
KeyCode[KeyCode.H] = "H";
KeyCode[KeyCode.I] = "I";
KeyCode[KeyCode.J] = "J";
KeyCode[KeyCode.K] = "K";
KeyCode[KeyCode.L] = "L";
KeyCode[KeyCode.M] = "M";
KeyCode[KeyCode.N] = "N";
KeyCode[KeyCode.O] = "O";
KeyCode[KeyCode.P] = "P";
KeyCode[KeyCode.Q] = "Q";
KeyCode[KeyCode.R] = "R";
KeyCode[KeyCode.S] = "S";
KeyCode[KeyCode.T] = "T";
KeyCode[KeyCode.U] = "U";
KeyCode[KeyCode.V] = "V";
KeyCode[KeyCode.W] = "W";
KeyCode[KeyCode.X] = "X";
KeyCode[KeyCode.Y] = "Y";
KeyCode[KeyCode.Z] = "Z";
